var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditEmailMac(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7655",
    d: "M2.319 11.314l7.708-7.713-1.645-1.643L.674 9.671l-.647 1.757a.426.426 0 00.533.548zm8.515-8.513l.853-.852a.844.844 0 00.03-1.285l-.381-.388a.856.856 0 00-1.295.038l-.851.846z",
    fill: "#262626"
  })));
}
export default SvgEditEmailMac;